export default __webpack_public_path__ + "static/media/imageOffre.61bce3ec.png";